"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="cs">
      <body
        style={{
          margin: 0,
          minHeight: "100svh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#070C16",
          color: "#FFFFFF",
          fontFamily: "system-ui, sans-serif",
          textAlign: "center",
          padding: "24px",
        }}
      >
        <div>
          <p style={{ fontFamily: "monospace", fontSize: 12, color: "#6B7891" }}>
            NEOCEKÁVANÁ CHYBA
          </p>
          <h1 style={{ fontSize: 28, fontWeight: 400, margin: "20px 0 12px" }}>
            Něco se pokazilo.
          </h1>
          <p style={{ color: "#9AA6BC", maxWidth: 460, margin: "0 auto 24px" }}>
            Zkuste prosím stránku načíst znovu. Pokud chyba přetrvává, napište nám přímo.
          </p>
          <button
            type="button"
            onClick={reset}
            style={{
              background: "#EA6C04",
              color: "#0B1220",
              border: 0,
              borderRadius: 8,
              padding: "13px 22px",
              fontSize: 15,
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Zkusit znovu
          </button>
        </div>
      </body>
    </html>
  );
}
